import { render, staticRenderFns } from "./workday.vue?vue&type=template&id=50cdde94"
import script from "./workday.vue?vue&type=script&lang=js"
export * from "./workday.vue?vue&type=script&lang=js"
import style0 from "./workday.vue?vue&type=style&index=0&id=50cdde94&prod&lang=less"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports